import { create } from 'zustand';

export type SignalingConnectionState = 'idle' | 'connecting' | 'open' | 'closed' | 'error';

interface SignalingState {
  connectionState: SignalingConnectionState;
  lastError: string | null;
  setConnectionState: (state: SignalingConnectionState) => void;
  setError: (message: string | null) => void;
  reset: () => void;
}

export const useSignalingStore = create<SignalingState>((set) => ({
  connectionState: 'idle',
  lastError: null,
  setConnectionState: (connectionState) => set({ connectionState }),
  setError: (lastError) => set({ lastError }),
  reset: () => set({ connectionState: 'idle', lastError: null }),
}));
